<div class="{{ paddingClasses }} input__form"
  [ngClass]="(formGroup ? (formGroup.get(name)?.valid && !formGroup.get(name)?.touched ? 'valid':'invalid' ):null)">
  @if (label != '') {
    <label class="{{ paddingClasses }} so-text-3" [style]="labelStyle">{{label}}<app-so-required-mark
      [show]="requiredMark" /></label>
  }
  @if (formGroup) {
    <textarea [formControlName]="formGroup ?name:null" class="form-control" [rows]="rows" [attr.id]="inputId"
      [placeholder]="placeholder" [value]="text" [disabled]="disabled" [style]="areaStyles"
      [attr.maxlength]="maxlength ? maxlength : null" [maxLength]="maxlength" (input)="updateValue(getValue($event))"
      [SanitizeInput]="applySanitize" name="{{name}}" #textarea (click)="onCursorPositionChange()" (keyup)="onCursorPositionChange()"
      (keydown)="onKeyDown($event)" (paste)="onPaste($event)" (keypress)="onKeyPress($event)">
      {{text}}
    </textarea>
  }@else{
    @if(formControl){
      <textarea class="form-control" [rows]="rows" [attr.id]="inputId"
        [placeholder]="placeholder" [value]="text" [style]="areaStyles"
        [attr.maxlength]="maxlength ? maxlength : null" [maxLength]="maxlength" (input)="updateValue(getValue($event))"
        [SanitizeInput]="applySanitize" name="{{name}}" #textarea (click)="onCursorPositionChange()" (keyup)="onCursorPositionChange()"
        (keydown)="onKeyDown($event)" (paste)="onPaste($event)" (keypress)="onKeyPress($event)" [formControl]="formControl">
        {{text}}
      </textarea>
      @if(formControl.invalid && formControl.touched && formControl.errors) {
        <span class="input__form">
          <label class="invalid">
              @if (formControl.errors['forbiddenChars']) {
                    {{ 'chars_invalid' | translated : 'El texto contiene caracteres no permitidos:' }}
                    {{ formControl.errors['forbiddenChars'].join(' ') }}.
              }
              @if (formControl.errors['forbiddenEmojis']) {
                    No se permiten estos emojis:
                    {{ formControl.errors['forbiddenEmojis'].join(' ') }}.
              }
            </label>
          </span>
      }
    }@else{
      <textarea class="form-control" [rows]="rows" [attr.id]="inputId"
        [placeholder]="placeholder" [value]="text" [disabled]="disabled" [style]="areaStyles"
        [attr.maxlength]="maxlength ? maxlength : null" [maxLength]="maxlength" (input)="updateValue(getValue($event))"
        [SanitizeInput]="applySanitize" name="{{name}}" #textarea (click)="onCursorPositionChange()" (keyup)="onCursorPositionChange()"
        (keydown)="onKeyDown($event)" (paste)="onPaste($event)" (keypress)="onKeyPress($event)">
        {{text}}
      </textarea>
    }
  }
</div>
